<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">基本配置</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">店铺权限设置</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 teamManage -->
    <!-- 店铺权限设置 -->
    <div class="manage">
      <h2>店铺权限设置</h2>
      <p class="header">数据列表</p>
      <div class="btn-list">
        <div>
          <el-button :disabled="loading" plain :type="currentTab === 'all' ? 'primary' : 'info'" @click="onChangeStatus('all')">全部({{shopStatistics.totalCount || 0}})
          </el-button>
          <el-button :disabled="loading" plain :type="currentTab === 'ing' ? 'primary' : 'info'" @click="onChangeStatus('ing')">营业中({{shopStatistics.openCount || 0}})
          </el-button>
          <el-button :disabled="loading" plain :type="currentTab === 'close' ? 'primary' : 'info' " @click="onChangeStatus('close')">关闭({{shopStatistics.closedCount || 0}})
          </el-button>
        </div>       
      </div>
      <div class="table" v-loading="loading">
        <vxe-table align="center" keep-source :data="tableData.list">
          <vxe-table-column title="序号" field="rowNum"  width="60"></vxe-table-column>
          <vxe-table-column field="shopName" title="店铺名称" minWidth="195"></vxe-table-column>
          <vxe-table-column title="店铺ID" field="shopId"  width="80"></vxe-table-column>
          <vxe-table-column title="店铺状态" field="shopStatus"  width="80"></vxe-table-column>
          <vxe-table-column title="所属平台" field="platformName" width="110"></vxe-table-column>

          <vxe-table-column title="查看权限" minWidth="195">
            <template slot-scope="scope">
             <el-select v-model="scope.row.viewUsers" @click.native="openUserPicker('viewUser',scope.row)" value-key="userId" placeholder="选择查看权限" collapse-tags
                        size="small" multiple popper-class="hidden" >
                <el-option v-for="(user, index) in scope.row.viewUsers" :label="user.realName" :key="index" :value="user"></el-option>
            </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作权限" minWidth="195">
            <template slot-scope="scope">
             <el-select v-model="scope.row.operateUsers" @click.native="openUserPicker('operateUser',scope.row)" value-key="userId" placeholder="选择操作权限" collapse-tags
                        size="small" multiple popper-class="hidden" >
                <el-option v-for="(user, index) in scope.row.operateUsers" :label="user.realName" :key="index" :value="user"></el-option>
            </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="orderSyncStatus" width="100">
            <template slot="header" slot-scope="scope">
              <div class="title-word-break">订单是否<br/>已同步系统</div>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div class="page">
          <div class="block">
            <el-pagination background="" @current-change="handleCurrentChange" :current-page.sync="currentPage"
              :page-size="10" layout="total, prev, pager, next"
              :total="tableData.totalNum">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <org-picker :title="pickTitle" :multiple="true" ref="orgPicker" @ok="selectedUser" />
  </div>
</template>

<script>
import OrgPicker from "@/components/OrgPicker";
export default {
  components: { OrgPicker },
  data() {
    return {
      loading:false,
      currentTab:'all',
      tableData: {},
      totalNum: 0,
      currentPage: 1,
      pickType: '',
      pickTitle:'选择成员',
      shopId:'',
      shopStatistics:{}
    };
  },
  created() {
    this.fectData();
  },
  activated() {

  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fectData();
    },
   onChangeStatus(val) {
      this.currentTab = val;
      this.fectData()
    },
    // 选择人
    openUserPicker(type,row){
      this.shopId = row.shopId
      this.pickType = type
      let userList = []
      if (type == 'viewUser') {
        this.pickTitle = '设置查看权限成员'
        userList = row.viewUsers.map(item => ({
          id: item.userId,
          name: item.realName,
          type: 'user'
        }))
      }else if (type == 'operateUser') {
        this.pickTitle = '设置操作权限成员'
        userList = row.operateUsers.map(item => ({
          id: item.userId,
          name: item.realName,
          type: 'user'
        }))
      }
      console.log('userList:',userList)
      this.$refs.orgPicker.show(userList, 'user');

    },
     //用户选择回调
    selectedUser(data) {
      let ids = data.map(item => item.id)
      const postData = {
        shopId:this.shopId
      }
      if (this.pickType == 'viewUser') {
        postData.viewUserIds = ids
      }else if (this.pickType == 'operateUser') {
        postData.operateUserIds = ids
      }
      console.log('postData：',postData)
      this.loading = true
      this.$api.omsShopSet(postData).then(res => { 
        if (res.code == 0) {
          this.$message.success('修改成功')
          this.fectData()
        }
      }).finally(() => {
        this.loading = false
      });
    },
    // 职位列表
    fectData() {
      this.loading = true;
      let shopStatusObj = {
        'all':'',
        'ing':'1',
        'close':'0'
      };
      const params = { 
        pageNo: this.currentPage,
        pageSize: 10,
        shopStatus: shopStatusObj[this.currentTab], // 店铺状态（0关闭，1营业中）
      }
      this.$api.omsShopPermission(params).then(res => {
        if (res.code == 0) {
          this.tableData = res.data;
        }
        this.$api.omsShopStatistics().then(res => {
          if (res.code == 0) {
            this.shopStatistics = res.data;
          }
        })
      }).finally(() => {
        this.loading = false;
      });
    },
   
  },
};
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.content {
  padding: 10px;
  background: #fff;

   .btn-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .el-button {
      min-width: 128px;
      height: 36px;
      font-size: 16px;
      border: none;
    }

    div:nth-child(2) {
      button:first-child {
        color: #409EFF;
        border: 1px solid #409EFF;
      }
    }

    //.el-button--primary.is-plain{
    //  color: #000000;
    //  &:hover, &:hover {
    //    color: #ffffff;
    //  }
    //}

    .el-button--default {
      border: 0;
      color: #2d7edf;
    }
  }
}

.header {
  font-size: 16px;
  margin-bottom: 15px;
  // border-bottom: 1px solid #eee;
}



.manage {
  padding: 10px;
  background: #fff;
}

.page {
  text-align: right;
  margin-top: 10px;

  span {
    font-size: 15px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
  }

  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}


.title-word-break {
  word-break: break-all;
  line-height: 16px;
}

</style>
<style>
.hidden{
  display: none!important;
  z-index: -1!important;
  width: 0;
  height: 0;
  overflow: hidden;
}
.el-select{
  padding-right: 20px;
}
.el-select__tags{
  flex-wrap: nowrap;
}
.el-select .el-icon-close{
  display: none;
}
</style>